import { Typography } from "@mui/material";
import React from "react";

export default function Action({ data }) {
  return (
    <Typography
      fontWeight={600}
      color={data?.side === "Buy" ? "success.main" : "error.main"}
    >
      {data?.side}
    </Typography>
  );
}
